import styled, { css } from 'styled-components'

const Tooltip = styled.div`
  width: max-content;
  padding: 6px 8px;

  position: absolute;
  z-index: 99999;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);

  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #cccccc80;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  opacity: 0;
  transition: opacity 0.2s 0.2s ease;
  backface-visibility: hidden;
  pointer-events: none;

  &::before {
    content: '';
    width: 8px;
    height: 8px;

    position: absolute;
    top: -1px;
    left: 50%;
    transform: translate(-50%, -50%) rotateZ(45deg);

    background-color: inherit;
    border-top: inherit;
    border-left: inherit;
  }
`

export const withTooltip = css`
  position: relative;

  &:hover ${Tooltip} {
    opacity: 1;
    transition: opacity 0.2s 0.4s ease;
  }
`

export default Tooltip



// WEBPACK FOOTER //
// ./src/lib/components/Tooltip.jsx